import { UISimulation } from '@/components/help/UISimulation';
import { SimShell } from './simShell';

const D = 1900;

// API key configuration — 4 frames: integration card -> enter key -> test ->
// save.
function STCard(): JSX.Element {
  return (
    <SimShell step={1} total={4} title="Integration card">
      <div className="rounded border border-dash-border bg-dash-surface px-3 py-2 text-xs">
        <div className="flex items-center justify-between">
          <span className="text-dash-primary font-mono">anthropic_api_key</span>
          <span className="font-mono text-[10px] uppercase text-warning">not set</span>
        </div>
        <div className="text-[10px] text-dash-muted mt-0.5">AI · powers every pipeline call</div>
      </div>
    </SimShell>
  );
}

function STEnter(): JSX.Element {
  return (
    <SimShell step={2} total={4} title="Enter the key">
      <div className="rounded border border-accent/40 bg-dash-surface px-3 py-2 text-xs">
        <div className="font-mono text-dash-primary">sk-ant-••••••••••••</div>
        <div className="mt-1.5 text-[10px] font-mono uppercase text-warning">
          critical key — type CONFIRM to enable Save
        </div>
      </div>
    </SimShell>
  );
}

function STTest(): JSX.Element {
  return (
    <SimShell step={3} total={4} title="Test">
      <div className="rounded border border-accent/40 bg-accent/10 px-3 py-2 text-xs">
        <span className="font-mono text-[10px] uppercase text-accent">testing connection…</span>
        <div className="text-dash-secondary mt-1">A live call confirms the key works.</div>
      </div>
    </SimShell>
  );
}

function STSave(): JSX.Element {
  return (
    <SimShell step={4} total={4} title="Save">
      <div className="rounded border border-success/40 bg-success/10 px-3 py-2 text-xs">
        <div className="text-dash-primary">Saved. Changes apply within 10 seconds.</div>
        <div className="text-[10px] font-mono uppercase text-success mt-0.5">
          plaintext never touches localStorage
        </div>
      </div>
    </SimShell>
  );
}

export function SettingsApiKeysSimulation(): JSX.Element {
  return (
    <UISimulation
      steps={[
        { frame: <STCard />, label: 'Keys grouped by category', duration: D },
        { frame: <STEnter />, label: 'Critical keys need confirmation', duration: D },
        { frame: <STTest />, label: 'Test before you save', duration: D },
        { frame: <STSave />, label: 'Save applies within 10s', duration: D },
      ]}
    />
  );
}
